import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, Inject } from '@angular/core';
import { ProjectFile } from '../../../../data/project/project-file';
import { ProjectActivity } from '../../../../data/project/activity/project-activity';
import { trackEntityById, API_URL } from 'projects/core/src/public-api';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { ProjectService } from '../../../../data/project/project.service';
import { ProjectActivityService } from '../../../../data/project/activity/project-activity.service';
import { HttpEventType, HttpResponse, HttpProgressEvent } from '@angular/common/http';
import { MatSnackBarRef, SimpleSnackBar, MatSnackBar } from '@angular/material/snack-bar';
import { FileUpload } from 'primeng/fileupload/fileupload';
import { FileOpenerService } from '../../../../utils/fileOpener.service';
import { FileService } from 'projects/core/src/lib/misc/data/file/file.service';

@Component({
    selector: 'app-activity-files',
    templateUrl: './activity-files.component.html',
    styleUrls: ['./activity-files.component.scss']
})
export class ActivityFilesComponent implements OnInit, OnDestroy {

    @Input()
    projectId: number;

    @Input()
    activity: ProjectActivity;

    @Input()
    status: string;


    progressBar: number;

    trackEntityById = trackEntityById;

    @Output() updateFiles = new EventEmitter<File[]>();

    activeSnackBar: MatSnackBarRef<SimpleSnackBar>

    constructor(
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
        @Inject(API_URL) protected apiUrl: string,
        private snackBar: MatSnackBar,
        protected wsService: WsService,
        protected projectActivityService: ProjectActivityService
    ) { }

    ngOnInit() {

        if (!this.activity) {
            this.activity = {
                id: null,
                files: []
            }
        }
    }

  openFile(file: ProjectFile){
    this.fileOpenerService.openFile(file, this.activity.files, true)
  }

    uploadFile(files: File[], filesForm?: FileUpload) {

        if (this.status === 'Save') {

            const fileArray = [];

            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < files.length; i++) {
                fileArray.push(files[i])
            }

            this.projectActivityService.uploadFile(fileArray, this.activity.id).subscribe(httpEvent => {
                if (httpEvent.type === HttpEventType.UploadProgress) {
                    const progressEvent = httpEvent as HttpProgressEvent
                    this.progressBar = Math.ceil(progressEvent.loaded / progressEvent.total * 100 / 3) * 3


                }
                else if (httpEvent.type === HttpEventType.Response) {
                    const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
                    this.activity.files = this.activity.files.concat(projectFiles)
                    this.progressBar = 0
                }
                if (filesForm) {
                    filesForm.clear();
                }
            }, error => {
                this.progressBar = 0
                this.openSnackBar(error.message)
            })
        }
        else {

            const fileArray = [];

            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < files.length; i++) {
                fileArray.push(files[i])
                this.activity.files.push({
                    id: null,
                    name: files[i].name
                })
            }
            this.updateFiles.emit(fileArray)

            if (filesForm) {
                filesForm.clear();
            }
        }
    }

    deleteFile(file: ProjectFile) {

        if (this.status === 'Save') {

            this.projectActivityService.deleteFile(file.id, this.activity.id).subscribe(deleted => {

                const index = this.activity.files.indexOf(file, 0);
                if (index > -1) {
                    this.activity.files.splice(index, 1);
                }
            })
        }
        else {
            const index = this.activity.files.indexOf(file, 0);
            if (index > -1) {
                this.activity.files.splice(index, 1);
            }
        }

    }

    onProgress(event) {
        this.progressBar = event.progress;

        if (this.progressBar === 100) {
        }
    }

    getIcon(ext: string) {
        if (ext === 'jpg' || ext === 'png' || ext === 'gif' || ext === 'webp') {
            return 'photo';
        }
        else if (ext === 'pdf' || ext === 'doc' || ext === 'docx' || ext === 'txt') {
            return 'insert_drive_file';
        }
        else if (ext === 'zip' || ext === 'rar') {
            return 'archive';
        }
        else {
            return 'attach_file';
        }
    }

    updateProgressBar(percent: number) {
        this.progressBar = percent;
    }

    openSnackBar(message: string, duration = 5000) {
        if (this.activeSnackBar) {
            this.activeSnackBar.dismiss();
        }

        this.activeSnackBar = this.snackBar.open(message, '', {
            duration,
            panelClass: 'file-error-snackbar',
            verticalPosition: 'top',
        });
    }

    ngOnDestroy() {

    }

}
